/* eslint-disable max-len */
import { createSvgIcon } from '@mui/material/utils';

export const OutlineBriefcase = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26 27"
    fill="none"
  >
    <path d="M25 16.6734C21.1873 18.2151 17.1126 19.0051 13 19.0001C8.756 19.0001 4.70667 18.1734 1 16.6734M13 15.0001H13.0133M18.3333 7.00008V4.33341C18.3333 3.62617 18.0524 2.94789 17.5523 2.4478C17.0522 1.9477 16.3739 1.66675 15.6667 1.66675H10.3333C9.62609 1.66675 8.94781 1.9477 8.44772 2.4478C7.94762 2.94789 7.66667 3.62617 7.66667 4.33341V7.00008H18.3333ZM3.66667 25.6667H22.3333C23.0406 25.6667 23.7189 25.3858 24.219 24.8857C24.719 24.3856 25 23.7073 25 23.0001V9.66675C25 8.9595 24.719 8.28123 24.219 7.78113C23.7189 7.28103 23.0406 7.00008 22.3333 7.00008H3.66667C2.95942 7.00008 2.28115 7.28103 1.78105 7.78113C1.28095 8.28123 1 8.9595 1 9.66675V23.0001C1 23.7073 1.28095 24.3856 1.78105 24.8857C2.28115 25.3858 2.95942 25.6667 3.66667 25.6667Z" stroke="#130F35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,
  'OutlineBriefcase',
);
